<div class="stats" *ngIf="rol==2">
    <app-tarjetadash valor={{asistenciaMesa}} titulo="Mis atenciones"></app-tarjetadash>
</div>

<div class="stats" *ngIf="rol==1">
    <app-tarjetadash valor={{totalAsistencias}} titulo="Asistencia total"></app-tarjetadash>
    <app-tarjetadash valor={{pendientes}} titulo="Pendientes"></app-tarjetadash>
    <app-tarjetadash valor={{totalAsistencias}} titulo="Total general"></app-tarjetadash>
    <app-tarjetadash valor={{asistenciaMesa}} titulo="Mis atenciones"></app-tarjetadash>
    <app-tarjetadash valor={{presenciales}} titulo="Presenciales"></app-tarjetadash>
    <app-tarjetadash valor={{representados}} titulo="Representados"></app-tarjetadash>
</div>
